
import React from "react";
import { MessageCircle, Search } from "lucide-react";
import { cn } from "@/lib/utils";

interface EmptyChatsProps {
  searchTerm?: string;
  variant?: 'standalone' | 'sidebar';
  className?: string;
}

export const EmptyChats: React.FC<EmptyChatsProps> = ({ searchTerm, variant = 'standalone', className }) => {
  if (searchTerm && searchTerm.trim().length > 0) {
    return (
      <div className={cn(
        "flex flex-col items-center text-center p-4",
        className
      )}>
        <div className={`bg-white/10 rounded-full flex items-center justify-center mb-4 ${variant === 'standalone' ? 'w-16 h-16' : 'w-12 h-12'}`}>
          <Search className={`text-white/50 ${variant === 'standalone' ? 'w-8 h-8' : 'w-6 h-6'}`} />
        </div>
        <h3 className={`font-medium text-white mb-2 ${variant === 'standalone' ? 'text-lg' : 'text-base'}`}>
          Nenhum resultado encontrado
        </h3>
        <p className={`text-white/60 max-w-sm ${variant === 'standalone' ? 'text-sm' : 'text-xs'}`}>
          Não encontramos conversas ou mensagens para "{searchTerm}". Tente buscar por outro termo.
        </p>
      </div>
    );
  }

  return (
    <div className={cn(
      "flex flex-col items-center text-center p-4",
      className
    )}>
      <div className={`bg-white/10 rounded-full flex items-center justify-center mb-4 ${variant === 'standalone' ? 'w-16 h-16' : 'w-12 h-12'}`}>
        <MessageCircle className={`text-white/50 ${variant === 'standalone' ? 'w-8 h-8' : 'w-6 h-6'}`} />
      </div>
      <h3 className={`font-medium text-white mb-2 ${variant === 'standalone' ? 'text-lg' : 'text-base'}`}>
        Nenhuma conversa ainda
      </h3>
      <p className={`text-white/60 max-w-sm ${variant === 'standalone' ? 'text-sm' : 'text-xs'}`}>
        Quando você começar a conversar com alguém, suas conversas aparecerão aqui.
      </p>
    </div>
  );
};
